import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

interface ErrorSectionProps {
  errorMessage?: string;
}

export const ErrorSection = ({ errorMessage }: ErrorSectionProps) => {
  return (
    <div className="flex flex-col py-10 items-center justify-center">
      <div className="bg-danger-50 rounded-full p-4 flex items-center justify-center">
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={64}
          className="text-danger-500"
        />
      </div>
      <p className="text-lg text-content-400">Error retrieving transactions</p>
      <p className="text-sm text-content-400">{errorMessage}</p>
    </div>
  );
};
